import React, { useEffect, useState } from "react"

export function DelayedRender({ ms = 500, children }: { ms?: number; children: React.ReactNode }) {
  const [render, setRender] = useState(ms <= 0)

  useEffect(() => {
    if (ms >= 0) {
      const timeout = setTimeout(() => {
        console.log("Setting render", ms)
        setRender(true)
      }, ms)

      return () => clearTimeout(timeout)
    }
  }, [])

  if (!render) {
    return <React.Fragment />
  } else {
    return <React.Fragment>{children}</React.Fragment>
  }
}
